var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F6F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.166 11.25H23.7722H31.9992V27.704H21.5572L16.7152 32.546C16.4002 32.861 15.8616 32.6379 15.8616 32.1925V27.704H10.166V11.25Z",
    stroke: "#F16434",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6563 21.288V21.413H20.7813H21.6698H21.7948V21.288V20.7868C21.7948 20.5082 21.9059 20.275 22.0864 20.0475C22.2345 19.8608 22.4218 19.6864 22.6253 19.497C22.6744 19.4513 22.7245 19.4048 22.7752 19.3569C23.2888 18.872 23.8339 18.2848 23.8339 17.3011C23.8339 16.6612 23.6061 16.095 23.1848 15.6889C22.7635 15.2829 22.1583 15.0459 21.4192 15.0459C20.063 15.0459 19.3995 15.9506 19.1714 16.5868L19.1327 16.6946L19.2368 16.7425L19.9544 17.0729L20.0683 17.1253L20.1204 17.0113C20.2081 16.8194 20.3357 16.5986 20.5355 16.426C20.7326 16.2558 21.0056 16.1275 21.3964 16.1275C21.801 16.1275 22.1088 16.2598 22.3154 16.4702C22.5225 16.6812 22.6384 16.9812 22.6384 17.3352C22.6384 18.0197 22.189 18.4509 21.6859 18.9322L21.6859 18.9322C21.1957 19.4014 20.6563 19.9175 20.6563 20.7526V21.288ZM21.2484 22.8493C20.8291 22.8493 20.4741 23.1872 20.4741 23.6122C20.4741 24.0372 20.8291 24.3751 21.2484 24.3751C21.6705 24.3751 22.0113 24.0344 22.0113 23.6122C22.0113 23.19 21.6705 22.8493 21.2484 22.8493Z",
    fill: "#F16434",
    stroke: "#F16434",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionGrey);
export default __webpack_public_path__ + "static/media/question_grey.13c970921cefad5e83b73dcefb0c9b4c.svg";
export { ForwardRef as ReactComponent };